import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import SearchSection from '../components/SearchSection';
import PropertiesSection from '../components/PropertiesSection';
import ServicesSection from '../components/ServicesSection';
import ProjectsSection from '../components/ProjectsSection';
import AboutSection from '../components/AboutSection';
import PhotoGallery from '../components/PhotoGallery';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import PropertyComparison from '../components/PropertyComparison';
import { useProperty } from '../context/PropertyContext';
import toast from 'react-hot-toast';

const Home = () => {
  const [searchResults, setSearchResults] = useState(null);
  const [showComparison, setShowComparison] = useState(false);
  const { compareList } = useProperty();

  const handleSearchResults = (results) => {
    setSearchResults(results);
  };

  return (
    <div className="home">
      <Navbar />
      <Hero />
      <SearchSection onSearchResults={handleSearchResults} />
      <PropertiesSection searchResults={searchResults} />
      <ServicesSection />
      <ProjectsSection />
      <AboutSection />
      <PhotoGallery />
      <ContactSection />
      <Footer />
      
      {/* Property Comparison Modal */}
      <PropertyComparison
        isOpen={showComparison}
        onClose={() => setShowComparison(false)}
      />
    </div>
  );
};

export default Home;